// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"796346c44faedf847ed1","655":"338febc31204a01cf983"}[chunkId] + ".js";
};